<div class="note-legacy-wrapper" >

    <div class="note-legacy-tools" [ngClass]="{'notes-creation-forbidden' : !canCreate}">
      <div *ngIf="canCreate" class="note-info">
        <h3>Add Notes</h3>
        <div>Double click on the area of the file below where you want to add a note.</div>
      </div>
        <core-helpers-forms-button-white [hidden]="!vnotesCtrl.hasUnsavedNotes() || !canCreate" [text]="'Save notes'" (submit)="sendNotes()"></core-helpers-forms-button-white>
    </div>

  <div class="button-tools">
    <div class="buttons">
        <button type="button" class="default zoom-out-img" (click)="viewerAction($event, 'zoom-out')" title="Zoom Out">
            <span class="zoomOut">Zoom Out</span>
        </button>
        <button type="button" class="default zoom-in-img" (click)="viewerAction($event, 'zoom-in')" title="Zoom In">
            <span class="zoomIn">Zoom In</span>
        </button>
        <button type="button" class="default rotate-img" (click)="viewerAction($event, 'rotate')" title="Rotate">
            <span class="rotate">Rotate</span>
        </button>
    </div>
</div>

    <div #scroll class="notes-image-scroll">
        <div #bounds class="note-legacy" > <!-- this layer is x/y content -->
            <div #notesContainer (dblclick)="makeNote($event)" class="notes-image-container" >

                <core-preview-page-viewer
                    *ngIf="page > 0"
                    [buttons]="false"
                    [fileId]="file.id"
                    [page]="page"
                    [format]="'big-width'"
                    (onLoad)="previewLoad($event)"
                    [viewer]="viewerCtrl.viewers[page]"
                    (viewerChange)="onViewerAction($event)"
                ></core-preview-page-viewer>

                <ng-container *ngIf="previewLoaded">
                <core-note-type-point
                    
                    *ngFor="let vnote of vnotesCtrl.findByPage(page, 'point');"
                    [index]="vnote.index"
                    [note]="vnote.note"
                    [viewerStatus]="viewerCtrl.status[page]"
                    [opened]="isSelected(vnote.note)"
                    [moveBounds]="notesBounds.nativeElement"
                    (onRemove)="deleteNote($event, vnote)"
                    (movingNote)="moveNote($event, vnote)"
                >
                </core-note-type-point>
                </ng-container>
            </div>
        </div>
    </div>


</div>
